import { Box, Grid, Paper, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import AppRadioButtonsGroup from "../../../app/components/AppRadioButtonsGroup";
import { RadioButtonValue } from "../../../app/models/radioButtonValue";
import { useEffect } from "react";
import membershipFormModel from "../../../app/models/membership/membershipFormModel";
import MemberLocation from "../../../app/models/membership/MemberLocation";
import { MapMagazinePreferenceToAutocompleteItems } from "../../../app/utils/convertStaticDataToDropdownItems";
import { useMsal } from "@azure/msal-react";
import { IdTokenClaims } from "../../../app/models/account/idTokenClaims";
import { alumniFilter, famFilter, affiliateAssociateFilter } from "../../../app/utils/util";
import { MESSAGE_NOT_A_VALUE } from "../../../app/utils/constant";
import { useAppSelector } from "../../../app/store/configureStore";
import AppAutocomplete from "../../../app/components/AppAutocomplete";

export function LocationAndPreferences() {
    const {
        AlumniMagazinePreference,
        SurgeonsScopeMagazine,
        TheSurgeonJournal,
        OptIntoDirectMarketing,
        ShareMyEmailWithMyClassmates,
        LocationCountry,
        CountrySubdivision,
        CurrentUserRoles
    } = membershipFormModel.formField;

    const { control, reset } = useFormContext();

    const yesNoArray: RadioButtonValue[] = [
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' }
    ]

    const { instance } = useMsal();
    const userRoles = (instance.getActiveAccount()?.idTokenClaims as unknown as IdTokenClaims).extension_portalcrm_userType.split(',');

    const { countries, publicationPreferences } = useAppSelector(state => state.ReferenceData);
    const { personalDetails } = useAppSelector(state => state.personalDetail);
    const { alumnusDetails } = useAppSelector(state => state.alumniDetails);
    const { famDetails } = useAppSelector(state => state.famDetails);

    useEffect(() => {
        if (countries && personalDetails && (famDetails || alumnusDetails)) {
            reset({
                [LocationCountry.name]: (personalDetails.locationCountryId === undefined || personalDetails.locationCountryId === null)
                    ? '' : personalDetails.locationCountryId,
                [CountrySubdivision.name]: (personalDetails.locationCountrySubdivisionId === undefined ||
                    personalDetails.locationCountrySubdivisionId === null)
                    ? MESSAGE_NOT_A_VALUE : personalDetails.locationCountrySubdivisionId,
                [SurgeonsScopeMagazine.name]: famDetails?.scopePreferenceId,
                [TheSurgeonJournal.name]: famDetails?.surgeonJournalPreferenceId,
                [AlumniMagazinePreference.name]: alumnusDetails?.alumniMagPreferenceId === null ? '' : alumnusDetails?.alumniMagPreferenceId,
                [OptIntoDirectMarketing.name]: (alumnusDetails?.directMarketingPreference &&
                    alumnusDetails?.directMarketingPreference === true) ? "Yes" : "No",
                [ShareMyEmailWithMyClassmates.name]: (alumnusDetails?.shareEmailPreference &&
                    alumnusDetails?.shareEmailPreference === true) ? "Yes" : "No",
                [CurrentUserRoles.name]: userRoles
            });
        }
    }, [countries, personalDetails, alumnusDetails, famDetails, reset]);

    return (
        <>
            {(alumniFilter(userRoles) || famFilter(userRoles) || affiliateAssociateFilter(userRoles)) &&
                <MemberLocation />
            }

            {(alumniFilter(userRoles) || famFilter(userRoles)) &&
                <Box sx={{ width: "100%" }} component={Paper}>
                    <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                        <Grid size={{ xs: 12 }}></Grid>

                        <Grid size={{ xs: 12 }}>
                            <Typography variant='subtitle1' sx={{ fontWeight: "500" }}>Publication preferences</Typography>
                        </Grid>

                        <Grid size={{ xs: 12 }}></Grid>

                        {alumniFilter(userRoles) &&
                            <Grid container rowSpacing={4} sx={{ marginLeft: "2%" }}>

                                <Grid size={{ xs: 12 }}>
                                    <Typography variant='body2' sx={{ fontWeight: "500" }}>Alumni Publication Preferences</Typography>
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    <AppAutocomplete control={control} name={AlumniMagazinePreference.name} label={AlumniMagazinePreference.label}
                                        items={MapMagazinePreferenceToAutocompleteItems(publicationPreferences ?? [])} />
                                </Grid>

                                <Grid size={{ xs: 12 }}></Grid>

                            </Grid>
                        }

                        {famFilter(userRoles) &&
                            <Grid container rowSpacing={4} sx={{ marginLeft: "2%" }}>

                                <Grid size={{ xs: 12 }}>
                                    <Typography variant='body2' sx={{ fontWeight: "500" }}>Member Publication Preferences</Typography>
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    <AppAutocomplete control={control} name={SurgeonsScopeMagazine.name} label={SurgeonsScopeMagazine.label}
                                        items={MapMagazinePreferenceToAutocompleteItems(publicationPreferences ?? [])} />
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    <AppAutocomplete control={control} name={TheSurgeonJournal.name} label={TheSurgeonJournal.label}
                                        items={MapMagazinePreferenceToAutocompleteItems(publicationPreferences ?? [])} />
                                </Grid>

                                <Grid size={{ xs: 12 }}></Grid>

                            </Grid>
                        }

                        {alumniFilter(userRoles) &&
                            <>
                                <Grid size={{ xs: 12 }}>
                                    <AppRadioButtonsGroup control={control} name={OptIntoDirectMarketing.name}
                                        label={OptIntoDirectMarketing.label} items={yesNoArray}
                                        information_text={OptIntoDirectMarketing.information_text} />
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    <AppRadioButtonsGroup control={control} name={ShareMyEmailWithMyClassmates.name}
                                        label={ShareMyEmailWithMyClassmates.label} items={yesNoArray} />
                                </Grid>
                            </>
                        }

                        <Grid size={{ xs: 12 }}></Grid>

                    </Grid>
                </Box>
            }
        </>
    );
}